import React from "react";
import clsx from "clsx";

import styles from "../../SelectPage.module.scss";

interface IActionColumnProps {
  stepNum: string;
  headerText: string;
  columnSub: string;
  children?: React.ReactNode;
  isEmpty?: boolean;
}

const ActionColumn: React.FC<IActionColumnProps> = ({
  stepNum,
  headerText,
  columnSub,
  children,
  isEmpty,
}) => {
  if (isEmpty) return <div className={styles.actionColumnEmpty} />;

  return (
    <div className={styles.actionColumn}>
      <div className={styles.columnHeader}>
        <div className={styles.verticalBar} />
        <span className={styles.stepNum}>{stepNum}</span>
        <span className={styles.headerText}>{headerText}</span>
      </div>
      <div className={styles.columnBody}>
        <div className={styles.columnSub}>{columnSub}</div>
        <div
          className={clsx(
            styles.cardList,
            stepNum === "02" && styles.materialCardList,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ActionColumn;
